import AlbumForm from 'src/sections/albums/album-form';

const CreateImport = ({ setSelection }) => <AlbumForm setSelection={setSelection} />;

export default CreateImport;
